import React, { FC } from 'react'
import SALink from 'components/SALink'
import styles from './ShopLocal.module.scss'
import AppConnector, { ConnectorProps as AppConnectorProps } from '../../connectors/App'
import DATA from 'data/shopLocal/countries.json'
const TITLE = 'Shop Local'

const ShopLocal: FC<AppConnectorProps> = ({ userStoreCountry }) => {
  const countryData = DATA.find((item) => item.code === userStoreCountry)
  if (!countryData) {
    return null
  }

  const { citizen, country, code } = countryData

  // TODO: Remove on July 1st
  if (code === 'US') {
    return (
      <div className={styles.callout}>
        <div className={styles.titleSection}>
          <p className={styles.calloutTitle}>Shop Original Art with Confidence</p>
          <p className={styles.calloutDescription}>
            Enjoy free 14-day returns on orders placed in June. Promotion applies to U.S. based collectors only. <em>Some exclusions may apply.</em>
          </p>
        </div>
        <SALink href='/all' title='Find Art You Love'>
          <div className={styles.getStartedButton}>
            <p className={styles.buttonText}>Find Art You Love</p>
          </div>
        </SALink>
      </div>
    )
  }

  return (
    <div className={styles.callout}>
      <div className={styles.titleSection}>
        <p className={styles.calloutTitle}>Shop {citizen} Artists</p>
        <p className={styles.calloutDescription}>
          {code === 'US' || code === 'VI'
            ? `Bring home art from nearly 10,000 U.S. artists - enjoy faster delivery times and avoid customs fees.`
            : `Bring home art from nearby artists - enjoy faster delivery times and avoid customs fees.`}
        </p>
      </div>
      <SALink href={`/all/${country.toLowerCase()}`} title={TITLE}>
        <div className={styles.getStartedButton}>
          <p className={styles.buttonText}>{TITLE}</p>
        </div>
      </SALink>
    </div>
  )
}

export default AppConnector(ShopLocal)
